<template>
    <main class="uiguide_main">
        <h1 class="uiguide_heading1">{{selectedTemplate.name}}</h1>
        <p>{{selectedTemplate.description}}</p>
        <div v-if="selectedTemplate.rules[0]">
            <h2 class="uiguide_heading2">Rules</h2>
            <ol>
                <li v-for="rule in selectedTemplate.rules" :key="rule">
                    <span>{{rule}}</span>
                </li>
            </ol>
        </div>
        <div v-if="selectedTemplate.styles[0]">
            <h2 class="uiguide_heading2">Style</h2>
            <ul>
                <li v-for="style in selectedTemplate.styles" :key="style">
                    <span>{{style}}</span>
                </li>
            </ul>
        </div>
        <div v-if="selectedTemplate.template === true">
            <h2 class="uiguide_heading2">Template</h2>
            <div class="uiguide_example">
                <template v-if="selectedTemplate.id === '1'" >
                    <Headers type="mainHeading" title="Main heading"/>
                    <Headers type="heading" title="Heading"/>
                    <Headers type="subHeading" title="Sub heading" />
                </template>
                <Para v-if="selectedTemplate.id === '4'" />
                <UnorderedList v-if="selectedTemplate.id === '5'" />
                <template v-if="selectedTemplate.id === '6'" >
                    <DescriptionList />
                    <DescriptionList type="linearised" />
                </template>
                <VerticalText v-if="selectedTemplate.id === '8'" />
                <Link v-if="selectedTemplate.id === '9'" />
                <Notes v-if="selectedTemplate.id === '10'" />
                <ResultsList v-if="selectedTemplate.id === '11'" />
                <Colours v-if="selectedTemplate.id === '12'" />
                 <template v-if="selectedTemplate.id === '13'" >
                    <Messages type="message" />
                    <Messages type="warning" />
                    <Messages type="confirmation" />
                </template>
                <Key v-if="selectedTemplate.id === '16'" />
                <Gallery v-if="selectedTemplate.id === '17'" />
                <RiskIcons v-if="selectedTemplate.id === '18'" />
                <template v-if="selectedTemplate.id === '19'" >
                    <LocationLevelIcons type="region"/>
                    <LocationLevelIcons type="site"/>
                    <LocationLevelIcons type="building"/>
                    <LocationLevelIcons type="floor"/>
                    <LocationLevelIcons type="room"/>
                </template>
                <template v-if="selectedTemplate.id === '20'" >
                    <DestinationLevelIcons type="region"/>
                    <DestinationLevelIcons type="site"/>
                    <DestinationLevelIcons type="building"/>
                    <DestinationLevelIcons type="floor"/>
                    <DestinationLevelIcons type="room"/>
                </template>
                <template v-if="selectedTemplate.id === '21'" >
                    <Flags type="message" message="Flag message" />
                    <Flags type="warning" message="Flag message" />
                    <Flags type="confirmation" message="Flag message"/>
                </template>
                <template v-if="selectedTemplate.id === '24'" >
                    <TextBox type="large" />
                    <TextBox type="medium" />
                    <TextBox type="small" />
                    <TextBox type="mandatory" />
                    <TextBox type="warning" />
                    <TextBox type="disabled" />
                    <TextBox type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '25'" >
                    <Checkbox />
                    <Checkbox type="vertical" />
                    <Checkbox type="warning" />
                    <Checkbox type="mandatory" />
                    <Checkbox type="disabled" />
                    <Checkbox type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '26'" >
                    <Radios />
                    <Radios type="vertical" />
                    <Radios type="mandatory" />
                    <Radios type="warning" />
                    <Radios type="disabled" />
                    <Radios type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '27'" >
                    <Dropdowns />
                    <Dropdowns type="mandatory" />
                    <Dropdowns type="warning" />       
                    <Dropdowns type="disabled" />
                    <Dropdowns type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '28'" >
                    <Textarea />
                    <Textarea type="mandatory" />
                    <Textarea type="warning" />
                    <Textarea type="disabled" />
                    <Textarea type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '29'" >
                    <TextBoxMoney />
                    <TextBoxMoney type="mandatory" />
                    <TextBoxMoney type="warning" />
                    <TextBoxMoney type="disabled" />
                    <TextBoxMoney type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '30'" >
                    <TextBoxPercent />
                    <TextBoxPercent type="mandatory" />
                    <TextBoxPercent type="warning" />
                    <TextBoxPercent type="disabled" />
                    <TextBoxPercent type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '31'" >
                    <Year />
                    <Year type="mandatory" />
                    <Year type="warning" />
                    <Year type="disabled" />
                    <Year type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '32'" >
                    <Submit />
                    <Submit type="primary" />
                    <Submit type="disabled" />
                    <Submit type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '33'" >
                    <Date />
                    <Date type="mandatory" />
                    <Date type="warning" />
                    <Date type="disabled" />
                    <Date type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '34'" >
                    <Email />
                    <Email type="mandatory" />
                    <Email type="warning" />
                    <Email type="disabled" />
                    <Email type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '35'" >
                    <TextBoxButtonCombo />
                    <TextBoxButtonCombo type="mandatory" />
                    <TextBoxButtonCombo type="warning" />
                    <TextBoxButtonCombo type="disabled" />
                    <TextBoxButtonCombo type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '36'" >
                    <TextBoxDropdownCombo />
                    <TextBoxDropdownCombo type="mandatory" />
                    <TextBoxDropdownCombo type="warning" />
                    <TextBoxDropdownCombo type="disabled" />
                    <TextBoxDropdownCombo type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '37'" >
                    <StartEndDateCombo />
                    <StartEndDateCombo type="mandatory" />
                    <StartEndDateCombo type="warning" />
                    <StartEndDateCombo type="disabled" />
                    <StartEndDateCombo type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '38'" >
                    <CheckboxTextBoxCombo />
                    <CheckboxTextBoxCombo type="mandatory" />
                    <CheckboxTextBoxCombo type="warning" />
                    <CheckboxTextBoxCombo type="disabled" />
                    <CheckboxTextBoxCombo type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '39'" >
                    <Legend />
                    <Legend type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '40'" >
                    <form class="micad_form">[legends, Form elements]</form>
                </template>
                <template v-if="selectedTemplate.id === '41'" >
                    <ReadOnly />
                    <ReadOnly type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '42'" >
                    <ProgressBar />
                    <ProgressBar type="linearised" />
                </template>
                <template v-if="selectedTemplate.id === '43'" >
                    <div class="micad_formElement micad_formElement_container">
                        <div class="micad_formElement_label">Lorem ipsum dolor sit amet</div>
                        <div class="micad_formElement_control">
                            [Place element here]
                        </div>
                    </div>
                    <div class="micad_formElement micad_formElement_container micad_formElement_linearised">
                        <div class="micad_formElement_label">Lorem ipsum dolor sit amet</div>
                        <div class="micad_formElement_control">
                            [Place element here]
                        </div>
                    </div>
                </template>
                <template v-if="selectedTemplate.id === '44'" >
                    <UserMenu />
                </template>
                <template v-if="selectedTemplate.id === '45'" >
                    <div class="micad_tileGrid">
                        <div class="micad_tileGrid_cell">
                             <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                             <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                            <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                            <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                            <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                            <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                            <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                        <div class="micad_tileGrid_cell">
                            <div style="background-color: gray; width: 100px; height: 100px; margin: 10px">Dummy tile</div>
                        </div>
                    </div>
                </template>
                <template v-if="selectedTemplate.id === '46'" >
                    <div class="micad_tile micad_tile_appLauncher micad_tile_demo micad_tile_spaceManagement">
                        <div class="micad_tile_header">Space management</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_asbestosApp">
                        <div class="micad_tile_header">Asbestos</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_propertyAppraisal">
                        <div class="micad_tile_header">Appraisal</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_roomUtilisation">
                        <div class="micad_tile_header">Room booking</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_demo micad_tile_leases">
                        <div class="micad_tile_header">Leases</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_audit">
                        <div class="micad_tile_header">Audit</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                     <div class="micad_tile micad_tile_appLauncher micad_tile_cafm">
                        <div class="micad_tile_header">CAFM</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                     <div class="micad_tile micad_tile_appLauncher micad_tile_zetaSafe">
                        <div class="micad_tile_header">ZetaSafe</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                     <div class="micad_tile micad_tile_appLauncher micad_tile_demo micad_tile_informationPortal">
                        <div class="micad_tile_header">Portals</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_analiticsCentre">
                        <div class="micad_tile_header">Analitics centre</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_reactiveMaintenance">
                        <div class="micad_tile_header">Scurity</div>
                        <p class="micad_tile_subtext">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                    <div class="micad_tile micad_tile_appLauncher micad_tile_auditTrail">
                        <div class="micad_tile_header">Audit-Trail</div>
                        <p class="micad_tile_subText">Lorem ipsum</p>
                        <button class="micad_tile_button">Launch App</button>
                    </div>
                </template>
                <template v-if="selectedTemplate.id === '47'" >
                    <Icons name="service_analiticsCentre" size="large" />
                    <Icons name="service_asbestosApp" size="large"/>
                    <Icons name="service_audit" size="large"/>
                    <Icons name="service_auditTrail" size="large"/>
                    <Icons name="service_cafm" size="large"/>
                    <Icons name="service_informationPortal" size="large"/>
                    <Icons name="service_leases" size="large"/>
                    <Icons name="service_propertyAppraisal" size="large"/>
                    <Icons name="service_roomUtilisation" size="large"/>
                    <Icons name="service_reactiveMaintenance" size="large"/>
                    <Icons name="service_spaceManagement" size="large"/>
                    <Icons name="service_zetaSafe" size="large"/>
                </template>
                 <template v-if="selectedTemplate.id === '48'" >
                    <UserDetails />
                </template>
                <template v-if="selectedTemplate.id === '49'" >
                    <Logo type="micad"/>
                </template>
                <template v-if="selectedTemplate.id === '50'" >
                    <div class="micad_framework_header">
                        <div class="micad_framework_header_logo">
                            <Logo type="micad"/>
                        </div>
                        <div class="micad_framework_header_coBranding">
                            <img class="micad_coBranding" src="https://www.ox.ac.uk/sites/default/themes/custom/oxweb/images/oxweb-logo.gif">
                        </div>
                         <div class="micad_framework_header_user">
                            <UserDetails />
                            <UserMenu />
                        </div>
                    </div>
                </template>
            </div>
        </div>
            <h2 class="uiguide_heading2">HTML</h2>
            <textarea class="uiguide_html"></textarea>
    </main>
</template>

<script>
import Headers from '@/components/templates/headings.vue';
import Para from '@/components/templates/para.vue';
import UnorderedList from '@/components/templates/unordered-list.vue';
import DescriptionList from '@/components/templates/description-list.vue';
import VerticalText from '@/components/templates/vertical-text.vue';
import Link from '@/components/templates/link.vue';
import Notes from '@/components/templates/notes.vue';
import ResultsList from '@/components/templates/results-list.vue';
import Colours from '@/components/templates/colours.vue';
import Messages from '@/components/templates/messages.vue';
import Key from '@/components/templates/key.vue';
import Gallery from '@/components/templates/gallery.vue';
import RiskIcons from '@/components/templates/risk-icons.vue';
import LocationLevelIcons from '@/components/templates/location-level-icons.vue';
import DestinationLevelIcons from '@/components/templates/destination-level-icons.vue';
import Flags from '@/components/templates/flags.vue';
import TextBox from '@/components/templates/text-box.vue';
import Checkbox from '@/components/templates/checkbox.vue';
import Radios from '@/components/templates/radios.vue';
import Dropdowns from '@/components/templates/dropdown.vue';
import Textarea from '@/components/templates/textarea.vue';
import TextBoxMoney from '@/components/templates/text-box-money.vue';
import TextBoxPercent from '@/components/templates/text-box-percent.vue';
import Year from '@/components/templates/year.vue';
import Submit from '@/components/templates/submit.vue';
import Date from '@/components/templates/date.vue';
import Email from '@/components/templates/email.vue';
import TextBoxButtonCombo from '@/components/templates/text-box-button-combo.vue';
import TextBoxDropdownCombo from '@/components/templates/text-box-dropdown-combo.vue';
import StartEndDateCombo from '@/components/templates/start-end-date-combo.vue';
import CheckboxTextBoxCombo from '@/components/templates/checkbox-text-box-combo.vue';
import Legend from '@/components/templates/legend.vue';
import ReadOnly from '@/components/templates/read-only.vue';
import ProgressBar from '@/components/templates/progressBar.vue';
import UserMenu from '@/components/templates/user-menu.vue';
import Icons from '@/components/templates/icons.vue';
import UserDetails from '@/components/templates/user-details.vue';
import Logo from '@/components/templates/logo.vue';
export default {

    name: 'component-detials',
    watch: {
        selectedTemplate: function () {
            this.$nextTick(() => {
                 if(document.getElementsByClassName("uiguide_example")[0] !== undefined){
                     var templateHtml = document.getElementsByClassName("uiguide_example")[0].innerHTML.replace(/<!---->/g, "");
                    document.getElementsByClassName("uiguide_html")[0].innerHTML = templateHtml;
                 }
            });
        }
    },
    props: {
      selectedTemplate: {
        type: Object,
        default: () => {},
      },
    },
    components: {
    Headers, 
    Para, 
    UnorderedList, 
    DescriptionList, 
    VerticalText, 
    Link, 
    Notes, 
    ResultsList, 
    Colours, 
    Messages, 
    Key, 
    Gallery, 
    RiskIcons, 
    LocationLevelIcons, 
    DestinationLevelIcons, 
    Flags, 
    TextBox, 
    Checkbox,
    Radios, 
    Dropdowns, 
    Textarea, 
    TextBoxMoney, 
    TextBoxPercent, 
    Year, 
    Submit,
    Date,
    Email,
    TextBoxButtonCombo,
    TextBoxDropdownCombo,
    StartEndDateCombo,
    CheckboxTextBoxCombo,
    Legend,
    ReadOnly,
    ProgressBar,
    UserMenu,
    Icons,
    UserDetails,
    Logo
    },
};
</script>